import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../../slices/common/reducer";
import {
  filterDateOptions,
  getEntityType,
  handleFilterDateChange,
} from "../../../../Utils/CommonUtils";
import { setRoleFilterForm } from "../../../../slices/team/roles/rolesSlice";
import { ROL_FROM_DATE, ROL_TO_DATE } from "../../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";
import "./Role.scss";
import { getRoles } from "../Users/UserService";
import { useEffect } from "react";

const RoleFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.roles.filter.form);

  // Reset tab and pagination when filters change
  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  // Handle input changes for text and select fields
  const handleInputChange = (name, value) => {
    dispatch(setRoleFilterForm({ name, value }));
    resetTabAndPageNumber(); // Resetting tab and page number
    dispatch(TriggerFilterButtonApi()); // Trigger the API call
  };

  // Order status options
  const roleOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "INACTIVE", label: "Inactive" },
  ];

  const handleClear = () => {
    dispatch(setRoleFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-5">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Role..."
                name="filter_ref"
                id="code"
                value={filterForm.filter_ref || ""}
                className="role-searchbar"
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                } // Update on change
              />
            </InputGroup>
          </Form.Group>
          {/* <Form.Group as={Col} className="col-md-4">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[ROL_FROM_DATE]
                  ? new Date(filterForm[ROL_FROM_DATE])
                  : null,
                filterForm[ROL_TO_DATE]
                  ? new Date(filterForm[ROL_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setRoleFilterForm,
                  ROL_FROM_DATE,
                  ROL_TO_DATE
                )
              }
            />
          </Form.Group> */}
          <Form.Group as={Col} className="col-md-5">
            <Select
              isClearable
              placeholder="All Status"
              name="status"
              options={roleOptions}
              value={
                roleOptions.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="clear-btn">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default RoleFilter;
